import { getAllTeacherNames, createTeacher, licenseAllUsers } from './'

/**
 * Creates all teachers that are mentioned in the upload data
 * but have not been created yet in the database and associates
 * these teachers with their school.
 * @param {array} uploadData The parsed array of row objects from the csv upload
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 */
export default function createTeachers (uploadData, school, schoolYear, assessmentId, assessment) {
  const { teacherNamesOnly } = getAllTeacherNames(uploadData)

  const promises = teacherNamesOnly.map(name => 
    createTeacher(name, school, schoolYear)
  )

  let output
  
  return Promise.all(promises)
    .then(createdTeachers => {
      output = createdTeachers.filter(teacher => teacher)
      return licenseAllUsers(createdTeachers, school, assessmentId, assessment, 'educator')
    })
    .then(() => {
      return output
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createTeachers.js